<template>
  <div>
    <v-dialog
      @keydown.esc="isOpen=false"
      v-model="isOpen"
      persistent
      max-width="400">
      <v-card>
        <v-card-title>
          Agrega un producto a la orden {{ order.uuid }}
        </v-card-title>
        <v-card-text>
          <v-form
            ref="form"
            v-model="validAddProduct">
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  v-model="product"
                  :items="products.data"
                  :loading="products.loading"
                  label="Producto"
                  item-text="name"
                  item-value="uuid"
                  clearable
                  hide-selected
                  hide-no-data
                  return-object
                  :rules="form.rules.required"
                  @change="productSelected"
                  @input.native="search($event)" />
              </v-col>
              <v-col cols="12">
                <v-select
                  ref="choice_select"
                  v-model="form.data.variant"
                  :disabled="choices.disabled"
                  :items="choices.data"
                  label="Presentación"
                  item-text="name"
                  item-value="uuid"
                  :rules="form.rules.required"
                  @keyup.up="activateChoiceMenu"
                  @keyup.down="activateChoiceMenu"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Cantidad"
                  v-model.number="form.data.quantity"
                  :rules="form.rules.required"
                  type="number" />
              </v-col>
            </v-row>
          </v-form>
          <div
            v-if="productsCatalogPermissions['create-product']"
            class="display-flex justify-between">
            <v-list-item>
              <v-list-item-title>
                Agregar un producto nuevo
              </v-list-item-title>
              <v-list-item-action>
                <v-btn
                  data-cy="addProduct"
                  fab
                  x-small
                  depressed
                  color="primary"
                  @click="openCreateProductDialog"
                >
                  <v-icon color="white">mdi-plus</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            rounded
            outlined
            color="primary"
            @click.stop="cancelAddProduct">
            Cancelar
          </v-btn>
          <v-btn
            rounded
            color="primary"
            @click.stop="addProduct">
            Entendido
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <CreateProduct ref="createProduct"/>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import CreateProduct from '@/components/modals/CreateProduct'

export default {
  components: {
    CreateProduct
  },
  data () {
    return {
      isOpen: false,
      overlay: false,
      order: {},
      validAddProduct: false,
      product: {},
      products: {
        data: [],
        loading: false
      },
      choices: {
        data: [],
        disabled: true,
        loading: false
      },
      form: {
        data: {
          variant: null,
          quantity: null
        },
        rules: {
          required: [v => !!v || this.$t('validations.required')]
        }
      }
    }
  },
  computed: {
    provider () {
      return this.$store.state.currentProvider.data || ''
    },
    productsCatalogPermissions () {
      return this.$store.state.login.permissions['products-catalog'].components['products-catalog-list'].actions
    }
  },
  methods: {
    openCreateProductDialog () {
      this.$refs.createProduct.open()
    },
    open (order) {
      this.isOpen = true
      this.order = order
    },
    close () {
      this.isOpen = false
      this.choices.disabled = true
    },
    resetForm () {
      this.$refs.form.resetValidation()
      this.form.data = {
        product: null,
        choice: null,
        quantity: null,
        amount: null
      }
    },
    cancelAddProduct () {
      this.close()
      this.resetForm()
    },
    addProduct: async function () {
      this.$refs.form.validate()
      this.overlay = true
      if (this.validAddProduct) {
        try {
          const payload = this.form
          await this.$api.post(`/v1/orders/${this.order._id}/products`, payload)
          this.close()
          this.resetForm()
          this.$emit('updated')
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
      }
      this.overlay = false
    },
    async productSelected (event) {
      if (event) {
        const providerChoices = event.choices
          .filter(choice => choice.provider.id === this.provider._id)
          .map(choice => ({
            name: `${choice.displayQuantity} ${choice.display.name} de ${choice.contentQuantity} ${choice.unit.name} | $${Number(choice.amount).toFixed(2)}`,
            uuid: choice.uuid
          }))
        this.choices.data = providerChoices
        this.choices.disabled = !providerChoices.length
      }
    },
    search: debounce(async function (event) {
      this.products.loading = true
      const params = {
        name: `/${event.target.value}/i`,
        skip: 0,
        global: true,
        limit: 20,
        provider: this.$store.state.currentProvider.data._id
      }
      const products = await this.$api.get('/v1/products', params)
      this.products = {
        data: products.data,
        loading: false
      }
    }, 300),
    activateChoiceMenu (item) {
      this.$refs[`choice_select`].activateMenu()
    }
  }
}
</script>
